// ===== Eminence PDP: Shopify-style buy box =====
// Gallery thumbnails
(function(){
  const pdpThumbs = document.querySelectorAll('.pdp-shop-thumb');
  const pdpMainImg = document.getElementById('pdpShopMainImg');
  pdpThumbs.forEach(thumb=>{
    thumb.addEventListener('click', ()=>{
      if(!thumb.dataset.full) return;
      pdpThumbs.forEach(t=> t.classList.remove('active'));
      thumb.classList.add('active');
      if(pdpMainImg) pdpMainImg.src = thumb.dataset.full;
    });
  });

  // Color swatches — swap main gallery image, sync hidden variant select,
  // and update price/subtext to match the selected variant.
  //
  // pdpSwatches now potentially spans TWO separate rows on the standard
  // template (the main color row under the title, and the floating
  // bottom palette that fades in over the features section) — both use
  // the exact same .pdp-shop-swatch markup/data-variant-id. Matching
  // "active" by data-variant-id instead of just marking the one actually
  // clicked keeps both rows in sync no matter which one is used. Eminence
  // only ever has one row, so this is a no-op difference for it.
  const pdpSwatches = document.querySelectorAll('.pdp-shop-swatch');
  const pdpColorNames = document.querySelectorAll('#pdpColorName, #pdpFloatingColorName');
  const pdpVariantSelect = document.getElementById('pdpVariantSelect');
  // Same NodeList pattern as pdpColorNames above — the standard template
  // now also shows a price in the floating bottom bar (pdpFloatingPrice),
  // so both the main price and this one need to update together when a
  // swatch is clicked. Eminence only has the one #pdpPrice, so this is a
  // one-item, no-op-different NodeList for it, same as everywhere else
  // this pattern is used.
  const pdpPriceEls = document.querySelectorAll('#pdpPrice, #pdpFloatingPrice');
  // Now potentially TWO Add to Cart buttons on the standard template
  // (the main one, and the one added to the floating palette) — both
  // share the "pdp-shop-addcart" class (ids can't repeat), so this
  // queries all of them and keeps every one in sync together instead of
  // just the original single button. Eminence still only has one, so
  // this is a no-op difference for it, same as the swatches above.
  const pdpAddToBagButtons = document.querySelectorAll('.pdp-shop-addcart');
  const pdpAddToBag = document.getElementById('pdpAddToBag');
  const pdpPaymentVariantId = document.getElementById('pdpPaymentVariantId');

  pdpSwatches.forEach(swatch=>{
    swatch.addEventListener('click', ()=>{
      pdpSwatches.forEach(s=>{
        s.classList.toggle('active', s.dataset.variantId === swatch.dataset.variantId);
      });
      pdpColorNames.forEach(el=>{ el.textContent = swatch.dataset.color; });

      const img = swatch.dataset.image;
      if(img && pdpMainImg){
        pdpMainImg.src = img;
        let matched = false;
        pdpThumbs.forEach(t=>{
          t.classList.toggle('active', t.dataset.full === img);
          if(t.dataset.full === img) matched = true;
        });
        if(!matched) pdpThumbs.forEach(t=> t.classList.remove('active'));
      }

      const variantId = swatch.dataset.variantId;
      if(variantId){
        // Setting pdpPaymentVariantId.value tells Shopify's own dynamic
        // checkout/Shop Pay button (injected by Shopify, not in our
        // theme files — {{ form | payment_button }} in the buy box) that
        // the variant changed. That widget is known to re-render itself
        // on variant change and can pull the page's scroll position back
        // up to itself when it does, which is exactly the "jumps to the
        // top of the page" behavior reported here — most noticeable when
        // picking a color from the floating bottom bar since you're
        // scrolled far away from the buy box at that point. There's
        // nothing in our own code causing the jump, and no theme file to
        // fix on Shopify's side, so instead of chasing their script,
        // this locks the page's scroll position around that specific
        // assignment: capture it right before, then force it back
        // immediately after (and once more on the next frame, in case
        // their re-render happens asynchronously right after).
        const pdpScrollBefore = window.scrollY;
        const pdpRestoreScroll = ()=>{
          if(window.scrollY !== pdpScrollBefore) window.scrollTo(0, pdpScrollBefore);
        };

        if(pdpVariantSelect) pdpVariantSelect.value = variantId;
        if(pdpPaymentVariantId) pdpPaymentVariantId.value = variantId;
        const price = swatch.dataset.price;
        if(price) pdpPriceEls.forEach(el=>{ el.textContent = price; });
        const available = swatch.dataset.available === 'true';
        pdpAddToBagButtons.forEach(btn=>{
          btn.dataset.variantId = variantId;
          btn.classList.toggle('is-disabled', !available);
          btn.textContent = available ? 'Add to Bag' : 'Sold Out';
        });

        pdpRestoreScroll();
        requestAnimationFrame(pdpRestoreScroll);
        setTimeout(pdpRestoreScroll, 150);
      }
    });
  });

  // Quantity stepper
  const pdpQtyValue = document.getElementById('pdpQtyValue');
  const pdpQtyMinus = document.getElementById('pdpQtyMinus');
  const pdpQtyPlus = document.getElementById('pdpQtyPlus');
  let pdpQty = 1;
  function pdpRenderQty(){ if(pdpQtyValue) pdpQtyValue.textContent = pdpQty; }
  if(pdpQtyMinus) pdpQtyMinus.addEventListener('click', ()=>{ pdpQty = Math.max(1, pdpQty - 1); pdpRenderQty(); });
  if(pdpQtyPlus) pdpQtyPlus.addEventListener('click', ()=>{ pdpQty = Math.min(10, pdpQty + 1); pdpRenderQty(); });

  // Add to Cart — wired to the real Shopify Ajax Cart API via the
  // window.themeAddToCart(variantId, quantity) hook set up in theme.js.
  //
  // Real bug found live: double-clicking this button (or any two clicks
  // landing before the first request finished) fired themeAddToCart
  // twice at once. The native <cart-drawer>'s update() call doesn't
  // return a promise we can wait on, so the second open()/update() call
  // raced the first one — the result was the drawer's dimming overlay
  // showing on screen with the actual drawer panel never mounted (no
  // close button in the right place, nothing else visible), stuck until
  // the page was reloaded. Confirmed via live testing: two rapid clicks
  // added 2 items to the cart correctly on the server (/cart.js showed
  // it), but the drawer UI never rendered — the item just silently
  // wasn't shown. This guard makes the button ignore extra clicks while
  // a request is already in flight, so only one add-to-cart/open
  // sequence ever runs at a time.
  if(pdpAddToBagButtons.length){
    // Shared across every add-to-cart button (not one flag per button) —
    // clicking the main button and the floating palette's button back to
    // back should still only fire one add-to-cart request, same
    // reasoning as the original double-click guard below.
    let pdpAddToCartInFlight = false;
    pdpAddToBagButtons.forEach(btn=>{
      btn.addEventListener('click', (e)=>{
        e.preventDefault();
        if(btn.classList.contains('is-disabled')) return;
        if(pdpAddToCartInFlight) return;
        const variantId = btn.dataset.variantId;
        if(variantId && window.themeAddToCart){
          pdpAddToCartInFlight = true;
          pdpAddToBagButtons.forEach(b=> b.classList.add('is-loading'));
          Promise.resolve(window.themeAddToCart(variantId, pdpQty))
            .finally(()=>{
              pdpAddToCartInFlight = false;
              pdpAddToBagButtons.forEach(b=> b.classList.remove('is-loading'));
            });
        }
      });
    });
  }

  // Gallery height matches the info column down to the end of the
  // Description block (not the full right column).
  const pdpShopGallery = document.querySelector('.pdp-shop-gallery');
  const pdpShopInfo = document.querySelector('.pdp-shop-info');
  const pdpDescDetails = document.getElementById('pdpDescDetails');
  // Jordan asked for the gallery to just stay put on the standard PDP
  // template instead of growing/shrinking as Description opens and
  // closes — this whole height-syncing behavior is skipped there, so the
  // gallery just keeps its normal aspect-ratio:1/1 sizing from
  // eminence-pdp.css and never gets a JS-set inline height at all.
  // Guarded by presence of .pdp-standard-shop, which only exists in that
  // template's own markup — Eminence keeps the original sync behavior
  // exactly as before.
  const pdpIsStandardTemplate = !!document.querySelector('.pdp-standard-shop');
  function pdpSyncGalleryHeight(){
    if(pdpIsStandardTemplate) return;
    if(!pdpShopGallery || !pdpShopInfo || !pdpDescDetails) return;
    if(window.innerWidth <= 860){ pdpShopGallery.style.height = ''; return; }
    const infoTop = pdpShopInfo.getBoundingClientRect().top;
    const descBottom = pdpDescDetails.getBoundingClientRect().bottom;
    pdpShopGallery.style.height = Math.min(760, Math.max(300, descBottom - infoTop)) + 'px';
  }
  window.addEventListener('resize', pdpSyncGalleryHeight);
  if(pdpDescDetails) pdpDescDetails.addEventListener('toggle', pdpSyncGalleryHeight);
  window.addEventListener('load', pdpSyncGalleryHeight);
  pdpSyncGalleryHeight();

  // Standard PDP template's animated Description/Specifications/Features
  // accordion (pdp-standard-shop.liquid) — button + aria-expanded instead
  // of Eminence's native <details>/<summary>, since native <details> can't
  // be smoothly animated. This selector only matches the new markup, so
  // Eminence's own accordion (still real <details> elements) is untouched.
  // Re-runs the same gallery height sync above after the panel's own
  // transition finishes, since toggling one of these no longer fires a
  // native 'toggle' event the way <details> did.
  document.querySelectorAll('.pdp-accordion-summary').forEach(btn=>{
    btn.addEventListener('click', ()=>{
      const isOpen = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!isOpen));
      const panel = btn.nextElementSibling;
      if(panel){
        panel.addEventListener('transitionend', pdpSyncGalleryHeight, { once:true });
      }
    });
  });

  // Floating bottom color palette (pdp-standard-shop.liquid only) — fades
  // in once the separate feature diagram section
  // (pdp-feature-diagram.liquid, added further down the page) is scrolled
  // into view. Previously this also faded back OUT the moment the feature
  // diagram scrolled back out of view in either direction — so continuing
  // to scroll further DOWN past it (toward "You may also like", reviews,
  // etc.) made the palette disappear again, which wasn't wanted. Now it
  // only disappears when scrolling back UP past the same trigger point it
  // appeared at — staying visible for the rest of the page below that
  // point. Determined via entry.boundingClientRect.top: when the section
  // leaves view with its top edge below 0 (i.e. it's now below the
  // viewport — we scrolled back up above it), hide. When it leaves view
  // with its top edge above 0 (i.e. it's now above the viewport — we
  // scrolled on past it going down), leave it showing. threshold:0.15
  // means it needs to be about 15% visible before it counts as "in view"
  // for the initial fade-in.
  const pdpFloatingPalette = document.getElementById('pdpFloatingPalette');
  const pdpFeatureDiagram = document.querySelector('.pdp-feature-diagram');
  if(pdpFloatingPalette && pdpFeatureDiagram){
    const pdpPaletteObserver = new IntersectionObserver((entries)=>{
      entries.forEach(entry=>{
        if(entry.isIntersecting){
          pdpFloatingPalette.classList.add('is-visible');
        } else if(entry.boundingClientRect.top > 0){
          // Section is below the viewport again — we scrolled back up
          // past its trigger point, so hide.
          pdpFloatingPalette.classList.remove('is-visible');
        }
        // else: section is above the viewport (scrolled on past it going
        // down) — leave the palette showing, don't touch its class.
      });
    }, { threshold:0.15 });
    pdpPaletteObserver.observe(pdpFeatureDiagram);
  }
})();

// ===== Product video: play/pause toggle + pause when off-screen =====
(function(){
  const section = document.getElementById('pdpVideoSection');
  const video = document.getElementById('pdpVideoEl');
  const toggle = document.getElementById('pdpVideoToggle');
  if(!section || !video || !toggle) return;

  let userPaused = false;

  toggle.addEventListener('click', ()=>{
    if(video.paused){
      video.play();
      userPaused = false;
      section.classList.remove('is-paused');
      toggle.setAttribute('aria-label','Pause video');
    } else {
      video.pause();
      userPaused = true;
      section.classList.add('is-paused');
      toggle.setAttribute('aria-label','Play video');
    }
  });

  const videoObserver = new IntersectionObserver((entries)=>{
    entries.forEach(entry=>{
      if(entry.isIntersecting){
        if(!userPaused) video.play();
      } else {
        video.pause();
      }
    });
  }, { threshold:0.25 });
  videoObserver.observe(section);
})();

// ===== Eminence 360° viewer =====
(function(){
  const FRAME_COUNT = 21;
  const FRAMES = window.themeEminence360Frames || [];
  function frameUrl(i){ return FRAMES[i - 1] || ''; }

  const section = document.getElementById('pdp360Section');
  if(!section) return;
  const frame = document.getElementById('pdp360Frame');
  const zoomEl = document.getElementById('pdp360Zoom');
  const ambientEl = document.getElementById('pdp360Ambient');

  const siteHeaderEl = document.getElementById('siteHeader');
  function pdpFitHeader(){
    const h = siteHeaderEl ? Math.max(0, siteHeaderEl.getBoundingClientRect().bottom) : 0;
    document.documentElement.style.setProperty('--pdp-header-h', h + 'px');
    section.style.height = 'calc(240vh - ' + h + 'px)';
  }
  pdpFitHeader();
  window.addEventListener('resize', pdpFitHeader);

  const frameImgs = [];
  for(let i=1;i<=FRAME_COUNT;i++){
    const im = new Image();
    im.src = frameUrl(i);
    frameImgs.push(im);
  }

  const AMBIENT_BUILD_FRACTION = 0.55;
  const ZOOM_FRACTION = 0.16;
  const START_SCALE = 1.5;
  const START_OFFSET_VH = 65;
  const ROTATE_END = 0.42;
  const SHIFT_END = 0.52;

  const spacerEl = document.getElementById('pdp360FeaturesSpacer');
  const featuresTextEl = document.getElementById('pdp360FeaturesText');
  const featureEls = [
    document.getElementById('pdp360Feature1'),
    document.getElementById('pdp360Feature2'),
    document.getElementById('pdp360Feature3'),
  ];
  const FEATURES_WIDTH = 420;

  let last360Frame = -1;
  let ticking360 = false;

  function update360(){
    pdpFitHeader();
    const rect = section.getBoundingClientRect();
    const scrollRange = rect.height - window.innerHeight;
    if(scrollRange <= 0){ ticking360 = false; return; }

    let progress = -rect.top / scrollRange;
    progress = Math.max(0, Math.min(1, progress));

    if(ambientEl) ambientEl.style.opacity = Math.max(0.4, Math.min(1, progress / AMBIENT_BUILD_FRACTION));

    let scale, offsetVh, idx;
    if(progress <= ZOOM_FRACTION){
      const zp = progress / ZOOM_FRACTION;
      scale = START_SCALE + (1 - START_SCALE) * zp;
      offsetVh = START_OFFSET_VH * (1 - zp);
      idx = 0;
    } else if(progress <= ROTATE_END){
      scale = 1; offsetVh = 0;
      const rp = (progress - ZOOM_FRACTION) / (ROTATE_END - ZOOM_FRACTION);
      idx = Math.round(rp * (FRAME_COUNT - 1));
    } else {
      scale = 1; offsetVh = 0;
      idx = FRAME_COUNT - 1;
    }

    if(zoomEl) zoomEl.style.transform = 'translateY(' + offsetVh.toFixed(2) + 'vh) scale(' + scale.toFixed(4) + ')';
    if(idx !== last360Frame){
      if(frame) frame.src = frameUrl(idx + 1);
      last360Frame = idx;
    }

    if(spacerEl && window.innerWidth > 860){
      const shiftProgress = Math.max(0, Math.min(1, (progress - ROTATE_END) / (SHIFT_END - ROTATE_END)));
      spacerEl.style.width = (shiftProgress * FEATURES_WIDTH) + 'px';
    }

    const showFeatures = progress > SHIFT_END;
    if(featuresTextEl) featuresTextEl.classList.toggle('is-visible', showFeatures);
    featureEls.forEach(el=>{ if(el) el.classList.toggle('is-visible', showFeatures); });

    ticking360 = false;
  }

  window.addEventListener('scroll', ()=>{
    if(!ticking360){
      requestAnimationFrame(update360);
      ticking360 = true;
    }
  }, {passive:true});
  window.addEventListener('resize', update360);
  update360();

  const HIGHLIGHTS = {
    pdp360Feature1: { frame: 10 },
    pdp360Feature2: { frame: 17 },
    pdp360Feature3: { frame: 20 },
  };
  const HIGHLIGHT_ROTATE_MS = 550;
  let activeFeatureId = null;
  let highlightAnimTimer = null;

  function stepFramesTo(targetFrame, duration){
    const targetIdx = targetFrame - 1;
    let startIdx = last360Frame < 0 ? FRAME_COUNT - 1 : last360Frame;
    let diff = targetIdx - startIdx;
    if(Math.abs(diff) > FRAME_COUNT / 2){
      diff = diff > 0 ? diff - FRAME_COUNT : diff + FRAME_COUNT;
    }
    const steps = Math.max(1, Math.abs(diff));
    const dir = diff >= 0 ? 1 : -1;
    const stepTime = Math.max(28, duration / steps);
    let count = 0;
    clearInterval(highlightAnimTimer);
    highlightAnimTimer = setInterval(()=>{
      count++;
      const idx = ((startIdx + dir * count) % FRAME_COUNT + FRAME_COUNT) % FRAME_COUNT;
      if(frame) frame.src = frameUrl(idx + 1);
      last360Frame = idx;
      if(count >= steps){
        clearInterval(highlightAnimTimer);
        if(frame) frame.src = frameUrl(targetIdx + 1);
        last360Frame = targetIdx;
      }
    }, stepTime);
  }

  function setHighlightView(id){
    const h = HIGHLIGHTS[id];
    if(!h) return;
    stepFramesTo(h.frame, HIGHLIGHT_ROTATE_MS);
  }

  function clearHighlightView(){
    stepFramesTo(FRAME_COUNT, HIGHLIGHT_ROTATE_MS);
  }

  // Trying this on both desktop and mobile for now (not scoped to mobile
  // yet — easy to restrict later if desktop feels worse this way).
  // Expanding a feature (e.g. "Telescoping Handle") can push its panel's
  // bottom edge below the viewport. Previously a blanket "any scroll
  // collapses the open panel" listener sat here, which meant even trying
  // to scroll down to see the newly revealed content instantly snapped it
  // shut — no way to actually view it. That listener is gone; instead,
  // once the expand animation finishes (matches the .4s
  // grid-template-rows transition on .pdp-360-feature-panel), we measure
  // where the panel actually ended up and smooth-scroll it fully into
  // view automatically, so the user never has to fight for it.
  //
  // The .has-expanded-feature class toggled below is what lets
  // .pdp-360-pin grow past its normal fixed height on mobile (see
  // eminence-pdp.css) — it's ONLY added while a panel is actually open,
  // so the case image's own sizing during the spin itself (before
  // anything is expanded) is completely unaffected.
  const pinEl = document.getElementById('pdp360Section') ? document.getElementById('pdp360Section').querySelector('.pdp-360-pin') : null;

  document.querySelectorAll('.pdp-360-feature-expand').forEach(btn=>{
    btn.addEventListener('click', ()=>{
      const wasExpanded = btn.getAttribute('aria-expanded') === 'true';
      document.querySelectorAll('.pdp-360-feature-expand').forEach(b=>{
        b.setAttribute('aria-expanded', 'false');
      });
      if(!wasExpanded){
        btn.setAttribute('aria-expanded', 'true');
        activeFeatureId = btn.id;
        setHighlightView(btn.id);
        if(pinEl) pinEl.classList.add('has-expanded-feature');

        setTimeout(()=>{
          const panel = btn.parentElement ? btn.parentElement.querySelector('.pdp-360-feature-panel') : null;
          const target = panel || btn;
          const rect = target.getBoundingClientRect();
          const margin = 24;
          const overflowBelow = rect.bottom - window.innerHeight + margin;
          if(overflowBelow > 0){
            window.scrollBy({ top: overflowBelow, behavior: 'smooth' });
          }
        }, 420);
      } else {
        activeFeatureId = null;
        clearHighlightView();
        if(pinEl) pinEl.classList.remove('has-expanded-feature');
      }
    });
  });
})();

// ===== Subtle parallax on full-bleed photography =====
(function(){
  const pdpParallaxEls = document.querySelectorAll('[data-parallax]');
  if(!pdpParallaxEls.length) return;
  function pdpUpdateParallax(){
    pdpParallaxEls.forEach(el=>{
      const rect = el.parentElement.getBoundingClientRect();
      const vh = window.innerHeight;
      let progress = (vh - rect.top) / (vh + rect.height);
      progress = Math.max(0, Math.min(1, progress));
      const shift = (progress - 0.5) * 60;
      el.style.transform = `translateY(${shift}px) scale(1.12)`;
    });
  }
  window.addEventListener('scroll', ()=>{ requestAnimationFrame(pdpUpdateParallax); }, {passive:true});
  pdpUpdateParallax();
})();

// ===== Feature diagram (pdp-feature-diagram.liquid) — ONE photo stage, not
// two separate boxes. A tab row underneath it (Specifications + the
// feature tiles) crossfades the SAME photo to whichever tab's photo, and
// swaps the caption text. The measurement leader lines only show while
// the Specifications tab is active. The photo itself never moves or
// zooms, only swaps, so it always stays centered. No dots, no blocks, no
// auto-play — every change here is a direct result of clicking a tab. =====
(function(){
  const wrap = document.querySelector('.pdp-feature-diagram');
  if(!wrap) return;

  const tilesWrap = wrap.querySelector('.pdp-feature-tiles');
  const tiles = wrap.querySelectorAll('.pdp-feature-tile');
  const photoStage = wrap.querySelector('.pdp-feature-photo-stage');
  const photoImg = wrap.querySelector('.pdp-feature-photo-img');
  const captionEl = wrap.querySelector('.pdp-feature-tile-caption');

  // Crossfade timing: matches the .26s opacity transition on
  // .pdp-feature-photo-img in theme.css. Fade the current photo out, swap
  // its src at the same moment (a new Image() is kicked off fetching the
  // target URL right away, in parallel with the fade, so by the time the
  // fade-out finishes the browser almost always already has it decoded —
  // same preload-ahead-of-need trick used elsewhere in this section), then
  // fade the new photo in.
  const FADE_MS = 260;

  function swapTile(tileEl){
    if(!tileEl || !photoImg || tileEl.classList.contains('is-active')) return;
    const url = tileEl.dataset.image;
    const alt = tileEl.dataset.alt || '';

    tiles.forEach(t=> t.classList.toggle('is-active', t === tileEl));
    if(captionEl) captionEl.textContent = tileEl.dataset.text || '';
    if(tilesWrap) tilesWrap.classList.toggle('pdp-fd-specs', tileEl.dataset.specs === 'true');

    // No photo assigned to this tab yet in section settings — used to
    // silently do nothing here, which read as "the tabs don't work".
    // Now every tab always visibly reacts: either swap to its real photo,
    // or (nothing set) swap the stage to the "add a photo" placeholder.
    if(!url){
      if(photoStage) photoStage.classList.add('is-empty');
      return;
    }
    if(photoStage) photoStage.classList.remove('is-empty');

    const preload = new Image();
    preload.src = url;

    photoImg.style.opacity = '0';
    setTimeout(()=>{
      photoImg.src = url;
      photoImg.alt = alt;
      requestAnimationFrame(()=>{ photoImg.style.opacity = '1'; });
    }, FADE_MS);
  }

  tiles.forEach(tile=>{
    tile.addEventListener('click', ()=> swapTile(tile));
  });

  // Fade-in on scroll: flip .is-inview once the section is actually on
  // screen, which both photo stages and the tile row key off of in
  // theme.css. Runs once (unobserve after firing).
  if('IntersectionObserver' in window){
    const revealObserver = new IntersectionObserver((entries, obs)=>{
      entries.forEach(entry=>{
        if(entry.isIntersecting){
          wrap.classList.add('is-inview');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold:0.2 });
    revealObserver.observe(wrap);
  } else {
    wrap.classList.add('is-inview');
  }
})();